'use client'

import { MediaPlayer, MediaProvider } from '@vidstack/react'
import { DefaultAudioLayout, defaultLayoutIcons } from '@vidstack/react/player/layouts/default'
import { POLISH } from 'src/translations/vidstack'
import { useCurrentLocale } from 'src/i18n/client/useCurrentLocale'

const AudioPlayer = ({ title, audio, className = '', style }) => {
  const currentLocale = useCurrentLocale()
  const playerClassName = `w-full min-w-0 max-w-4xl ${className}`.trim()

  return (
    <MediaPlayer title={title} src={audio} viewType="audio" className={playerClassName} style={style}>
      <MediaProvider />
      <DefaultAudioLayout
        colorScheme="light"
        title={title}
        icons={defaultLayoutIcons}
        translations={currentLocale === 'pl' ? POLISH : null}
        slots={{
          seekBackwardButton: null,
          seekForwardButton: null,
          settingsMenu: null,
          startDuration: true,
        }}
      />
    </MediaPlayer>
  )
}

export { AudioPlayer }
